import type { ReactNode } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { BreadcrumbSchema } from "@/components/StructuredData";

interface LegalPageProps {
  title: string;
  /** Site path, e.g. "/impressum" (for the breadcrumb data). */
  path: string;
  /** Small line under the title, e.g. "Stand: September 2026". */
  subtitle?: string;
  children: ReactNode;
}

/** Plain text page for Impressum, Datenschutzerklärung and AGB: header, one readable column, footer. */
export function LegalPage({ title, path, subtitle, children }: LegalPageProps) {
  return (
    <div className="min-h-screen bg-background">
      <BreadcrumbSchema items={[{ name: "Startseite", url: "https://clicksdmp.com/" }, { name: title, url: `https://clicksdmp.com${path}` }]} />
      <Header />
      <main className="container-custom pt-32 pb-20">
        <article className="legal-content max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-4xl font-bold mb-2">{title}</h1>
          {subtitle && <p className="muted mb-8">{subtitle}</p>}
          {children}
        </article>
      </main>
      <Footer />
    </div>
  );
}

/** External link that opens in a new tab without leaking the referrer. */
export function Ext({ href, children }: { href: string; children?: ReactNode }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children ?? href}
    </a>
  );
}
